import { render, staticRenderFns } from "./yearCounter.vue?vue&type=template&id=0c3e8d00&scoped=true&"
import script from "./yearCounter.vue?vue&type=script&lang=js&"
export * from "./yearCounter.vue?vue&type=script&lang=js&"
import style0 from "./yearCounter.vue?vue&type=style&index=0&id=0c3e8d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e8d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3e8d00')) {
      api.createRecord('0c3e8d00', component.options)
    } else {
      api.reload('0c3e8d00', component.options)
    }
    module.hot.accept("./yearCounter.vue?vue&type=template&id=0c3e8d00&scoped=true&", function () {
      api.rerender('0c3e8d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/yearCounter.vue"
export default component.exports